import angular from 'angular'
import revisionsStandAlone from './revisions.standalone.component'
import revisionsHeaderBar from './revisions.headerbar.component'

export default angular
  .module('ellipsis.revisions', [])
  .component('revisionsStandAlone', revisionsStandAlone)
  .component('revisionsHeaderBar', revisionsHeaderBar)
